import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip,
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import { RowHelper } from "util/TableHelper";
import AccountTransactionRuleAddForm from "../Forms/AccountTransactionRuleAddForm";

const MultipleAccountTransactionRuleList = (props) => {

  const [options, setOptions] = useState({
    pageTitle: "ÇOKLU KURAL EKLEME LİSTESİ",
  });
  const [accountTransactionRules, setAccountTransactionRules] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [isUseForErp, setIsUseForErp] = useState(false);
  const [addData, setAddData] = useState({});

  useEffect(() => {
    checkForUseErp();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setAccountTransactionRules({
      ...accountTransactionRules,
      loading: true,
    });

    setAccountTransactionRules({
      data: props.data,
      loading: false,
      total: props.data.length,
    });
  };

  const checkForUseErp = () => {
    RequestHandler.get(`/AccountTransactionRule/CheckForUseErp`).then(
      (response) => {
        setIsUseForErp(response);
      }
    );
  };

  const onAddAccountTransactionRuleSuccess = () => {
    setAddFormVisibility(false);
    var tableData = accountTransactionRules.data.filter(
      (x) => x.id != addData.id
    );

    if (tableData.length === 0) {
      if (props.onSuccess) props.onSuccess();
    }

    setAccountTransactionRules({
      data: tableData,
      loading: false,
    });
  };

  const handleOnClickAdd = (data) => {
    setAddData(data);
    setAddFormVisibility(true);
  };

  const columns = [
    {
      title: "Açıklama",
      dataIndex: "key",
      key: "key",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: isUseForErp ? "Erp Kodu" : "Bayi Adı",
      dataIndex: isUseForErp ? "erpCode" : "firmName",
      key: isUseForErp ? "erpCode" : "firmName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: isUseForErp ? "İşlem Tipi" : "Bayi Sınıfı",
      dataIndex: isUseForErp ? "processType" : "firmClassName",
      key: isUseForErp ? "processType" : "firmClassName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Referans Kodu",
      dataIndex: "referenceCode",
      key: "referenceCode",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Proje Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 25).length < 25
              ? text.substring(0, 25) + ""
              : text.substring(0, 25) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Kural Ekle",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              handleOnClickAdd(row);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Kural Ekle
          </Button>
        );
      },
    },
  ];

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setAccountTransactionRules(e);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={accountTransactionRules.data}
            loading={accountTransactionRules.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: accountTransactionRules.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Drawer
        id="addAccountTransactionRuleDrawer"
        title="Kural Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <AccountTransactionRuleAddForm
          data={addData}
          onSuccess={onAddAccountTransactionRuleSuccess}
          isUseForErp={isUseForErp}
        />
      </Drawer>
    </>
  );
};

export default MultipleAccountTransactionRuleList;
